import axios from '../utils/axios'

const getNotifictions = () => {
    return new Promise((resolve, reject) => {
        const url = `/api/notifications`
        axios.get(url)
            .then(({data}) => {
                resolve(data?.data)
            }).catch(err => {
                reject(err)
            })
    })
}

const markNotificationsAsRead = () => {
    return new Promise((resolve, reject) => {
        const url = `/api/notifications/mark-as-read`
        axios.get(url)
            .then(({data}) => {
                resolve(data?.data)
            }).catch(err => {
                reject(err)
            })
    })
}

export {
    getNotifictions, markNotificationsAsRead
}
